import { useGlobalContext } from "../../../../Context/Context";
import Button from "../../../Custom/Button/Button";
import procenaRizikaImg from "../../../../picture/procena-rizika.png";

const obrazci = [
  "АКТ О ПРОЦЕНИ РИЗИКА",
  "ОДЛУКЕ И ЛИЦЕНЦЕ",
  "ПРВА ПОМОЋ",
  "ПРОЦЕНА УСЛОВА МЕДИЦИНЕ РАДА",
  "ТЕХНОЛОШКИ ПРОЦЕС",
  "СИСТЕМАТИЗАЦИЈА РАДНИХ МЕСТА",
  "ОРГАНИЗАЦИОНА ШЕМА",
  "ПРАВИЛНИЦИ И ПРОГРАМИ",
  "РЕГИСТРАЦИОНА ДОКУМЕНТА",
];

function ShowBarProcenaRizika() {
  const { selectedProcenaRizika, setSelectedProcenaRizika } =
    useGlobalContext();

  const handleClickObrazac = (index) => {
    if (selectedProcenaRizika !== index + 1) {
      setSelectedProcenaRizika(index + 1);
    } else {
      setSelectedProcenaRizika(0);
    }
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: "10px",
        }}
      >
        <img src={procenaRizikaImg} style={{ width: "40%" }} />
      </div>
      <div style={{ height: "500px", overflowY: "auto" }}>
        {obrazci.map((obrazac, i) => (
          <div onClick={() => handleClickObrazac(i)} key={i}>
            <Button
              active={selectedProcenaRizika === i + 1}
              style={{
                padding: "7px",
                fontWeight: "bold",
                textAlign: "left",
                minHeight: "64px",
                display: "block",
                fontSize: "16px",
              }}
            >
              {obrazac}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ShowBarProcenaRizika;
